import { render } from "./fileUpload.vue?vue&type=template&id=58cd2f0f&scoped=true"
import script from "./fileUpload.vue?vue&type=script&lang=js"
export * from "./fileUpload.vue?vue&type=script&lang=js"

import "./fileUpload.vue?vue&type=style&index=0&id=58cd2f0f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cd2f0f"]])

export default __exports__